import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Home from "@/components/Home";
import Test from "@/components/Test";
import BMPAlbum from "@/components/BMPAlbum";
import "./App.less";

function App() {
  return (
    <Router basename="/navigate">
      <div className="App" id="main-container">
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/test">
            <Test />
          </Route>
          <Route path="/bmp">
            <BMPAlbum />
          </Route>
        </Switch>
      </div>
    </Router>
  );
}

export default App;
